export async function getFoodsByCategory(category) {
  const maxSize = 12;
  const request = await fetch(`https://www.themealdb.com/api/json/v1/1/filter.php?c=${category}`);
  const { meals } = await request.json();
  return meals.slice(0, maxSize);
}

export async function getDrinksByCategory(category) {
  const maxSize = 12;
  const request = await fetch(`https://www.thecocktaildb.com/api/json/v1/1/filter.php?c=${category}`);
  const { drinks } = await request.json();
  return drinks.slice(0, maxSize);
}
